import React from 'react';
import ReactDOM from 'react-dom';
import { 
    VideoHighlightMessage,
    VideoHighlightHost 
} from '../../components/Video/Highlights';
import { VideoService } from '../../services/VideoService';

const timeoutDelay = 10000;

let container, activeTimeout;

const getVideoPlayerRef = () => document.querySelector('.video-js video.vjs-tech');

const buildContainer = () => {
    const container = document.createElement('div');
    container.className = 'video-highlight-container';
    return container;
};

const getContainer = () => {
    if (!container) {
        const ref = getVideoPlayerRef();
        if (ref) {
            container = buildContainer();
            ref.after(container);
        } else {
            return null;
        }
    }
    return container;
}

const removeHighlight = () => {
    // Clear active timeout
    if (activeTimeout) {
        clearTimeout(activeTimeout);
        activeTimeout = null;
    }
    // Empty highlight container
    if (container) ReactDOM.unmountComponentAtNode(container);
};

const addHighlight = (highlight) => { 
    const container = getContainer();

    if (!container) return;

    // Remove active highlights
    removeHighlight();

    // Insert highlight over video
    ReactDOM.render(highlight, container);
    // Remove highlight (after a delay)
    activeTimeout = setTimeout(() => removeHighlight(), timeoutDelay);
};

export const VideoHighlightService = {

    destroy: () => {
        removeHighlight();
        container = null;
    },

    message: (message) => {
        if (VideoService.checkFragmentId(message.fragmentId)) {
            addHighlight(<VideoHighlightMessage from={message.from} content={message.content} />);
        }
    },

    host: (host) => {
        if (VideoService.checkFragmentId(host.fragmentId)) {
            addHighlight(<VideoHighlightHost name={host.name} position={host.position} />);
        }
        
    },

};

export default VideoHighlightService;